import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Reusable dataset-attribute picker. Wraps the `ng-select` markup (including the
 * "(datasetName) attributeName" label/option templates) that was previously
 * duplicated across the recipe merge/transform/map templates.
 */
@Component({
    selector: 'app-attribute-select',
    templateUrl: './attribute-select.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AttributeSelectComponent), multi: true }
    ],
    standalone: false
})
export class AttributeSelectComponent implements ControlValueAccessor {
    @Input() items: any[] = [];
    @Input() placeholder = '';
    @Input() loading = false;

    public value: any = null;

    private onChange: (val: any) => void = () => { };
    private onTouched: () => void = () => { };

    public writeValue(val: any): void {
        this.value = val;
    }

    public registerOnChange(fn: (val: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public onValueChange(val: any): void {
        this.value = val;
        this.onChange(val);
        this.onTouched();
    }
}
